// extracted by mini-css-extract-plugin
export var section_wrapper = "faq-section-module--section_wrapper--2-vx0";
export var faq_list = "faq-section-module--faq_list--3P0qi";